// extracted by mini-css-extract-plugin
export default {"grid":"Input_grid__1xEGO","label_s":"Input_label_s__pxhJf","input_s":"Input_input_s__p1D3+","invalidGrid":"Input_invalidGrid__YavC8","input":"Input_input__aa+H+"};